import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';

export const DownloadModal = ({ children, downloadShow }) => {
  const [openState, setOpenState] = useState(downloadShow);

  useEffect(() => {
    setOpenState(downloadShow);
  }, [downloadShow]);

  return (
    <>
      <div
        onMouseEnter={() => {
          setOpenState(1);
        }}
        onMouseLeave={() => {
          setOpenState(0.5);
        }}
        className={
          openState === 1
            ? styles['download-modal'] + ' ' + styles['download-modal-open']
            : openState === 0.5
            ? styles['download-modal'] + ' ' + styles['download-modal-peek']
            : styles['download-modal']
        }
      >
        <span
          className={styles['download-modal-closebtn']}
          onClick={() => {
            setOpenState(0);
          }}
        >
          X
        </span>
        {children}
      </div>
    </>
  );
};
